// App.tsx - Using JSON file
import IslandView, { IslandData } from "./IslandView";
import islandData from "./Ga.Villingili.json";

function Ga_Villingili() {
  return <IslandView data={islandData as IslandData} />;
}

export default Ga_Villingili;